import getChildren from '@/util/getChildren'

/**
 * Get all VM instances of child fields
 * @return  {?Vue[]}
 */
export default {
  methods: {
    getFields () {
      var allChildren = getChildren(this)

      // Of all the children, only return ones with true data attribute 'isField'
      // that we define on all field components
      return allChildren.filter(vm => {
        return vm.isField
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/getFields.js